module.exports = __webpack_public_path__ + "static/media/1POLICY15.e9835126.jpg";